import { combineReducers } from "redux";
import ticket from "../features/admin/ticketraised/ticket/Slice";




const ticketraised = combineReducers({
   ticket: ticket,
  
  });
  
  export default ticketraised;